import React from "react";
import BlueArrow from "~/assets/icons/arrow-card.svg";
import s from "~/components/cards/speciality/SpecialityCard.module.scss";

interface Props {
  title: string;
  onClick: (id: number) => void;
}

const SpecialityCard: React.FC<Props> = ({ title, onClick }) => {
  return (
    <div className={s.specialityCard} onClick={() => onClick(12)}>
      <div className={s.specialityCardText}>{title}</div>
      <img src={BlueArrow} />
    </div>
  );
};

export default SpecialityCard;
